import ApiService from '@/core/api/api.service';
import store from '@/store';

import { functionsWithNotifications } from '@/core/notifications';
import vendorUserMessages from './vendor-user.messages';
import VendorUser from './vendor-user.mapper';

const functions = {
  get,
  clearCache,
};

export default {
  ...functionsWithNotifications(functions, vendorUserMessages),
};

const vendorUserApi = new ApiService();

async function get(userUuid) {
  const response = await vendorUserApi.get(`users/${userUuid}`);
  const vendorUser = new VendorUser(response.data.data);
  store.commit('setVendorUser', vendorUser);
  return vendorUser;
}

async function clearCache() {
  vendorUserApi.clearCache();
  store.commit('setVendorUser', null);
}
